import { apiClient } from '@/api/client';

// Client picks: the client picks an agreement's Optional services on a private page before it goes out for signature.
const data = (r) => r.data;
const P = (agreementId) => `/estimating/agreements/${agreementId}/client-picks`;
const L = (token) => `/proposal-link/${encodeURIComponent(token)}`;
const named = (name) => ({ params: name?.trim() ? { name: name.trim() } : {} });

export const getClientPicksEmailDraft = (agreementId, name) => apiClient.get(`${P(agreementId)}/email-draft`, named(name)).then(data);
export const sendClientPicks = (agreementId, body) => apiClient.post(P(agreementId), body).then(data);
// Sent for review: unlock to edit (the client's link stops working) → the composer view.
export const unlockReview = (agreementId) => apiClient.post(`${P(agreementId)}/unlock`).then(data);

// Settings → Agreements & invoices: "Let clients pick services" (off by default).
export const getClientPicksSetting = () => apiClient.get('/agreements/client-picks').then(data);
export const setClientPicksSetting = (on) => apiClient.put('/agreements/client-picks', { on }).then(data);
export const setPicksReminderDays = (days) => apiClient.put('/agreements/client-picks/reminder', { days }).then(data);

// The client's page: no login, the token is the key.
export const getPublicProposal = (token) => apiClient.get(L(token)).then(data);
export const quotePublicProposal = (token, chosen) => apiClient.post(`${L(token)}/quote`, { chosen }).then(data);
export const submitPublicProposal = (token, body) => apiClient.post(L(token), body).then(data);
